

export type AppRole = "Admin" | "Manager" | "Viewer" | "GlobalAdmin";

export const ROLES = {
  ADMIN: "Admin" as AppRole,
  MANAGER: "Manager" as AppRole,
  VIEWER: "Viewer" as AppRole,
  GLOBAL_ADMIN: "GlobalAdmin" as AppRole,
};

export const isGlobalAdmin = (role: string): boolean => {
  return role === "GlobalAdmin";
};